import { useTranslation } from 'react-i18next';

import type { ProductStatus, StoreProductStatus } from '@nucleus-commerce/api-client/admin';
import { Badge } from '@nucleus-commerce/ui/components/badge';

/** Shopify marks only the rows that would surprise: drafts and archived, unpublished in a store. */
export function PickerStatusBadge({ status }: { status: ProductStatus | StoreProductStatus }) {
  const { t } = useTranslation('common');
  if (status === 'active' || status === 'published') return null;
  return (
    <Badge variant="outline" className="text-muted-foreground shrink-0 font-normal">
      {t(`status.${status}`)}
    </Badge>
  );
}
